// src/api/authApi.ts
import request from '@/utils/request';

/**
 * 认证API模块
 */
export const authApi = {

    /**
     * 登录认证
     */
    loginAuth: (requestData: any) => {
        return request.post('/api/auth/login', requestData)
    }

};
